<ng-container *ngIf="isVisible$ | async">
  <div class="following-train-overlay" [ngClass]="(currentVelocity$ | async) === 0 ? 'box-red' : 'box-blue'">
    <div class="info-container" [ngClass]="(currentVelocity$ | async) === 0 ? 'info-red' : 'info-blue'">

      <div class="top-box-left">
        <div (click)="handleTrainNumberClick()" class="train-button">{{(currentTrain$ | async)?.properties.title | uppercase}} {{(currentTrain$ | async)?.properties.subTitle}}</div>
        <hr color="white">
        <div id="velocityWrapper">{{'Velocity' | translate}}: {{(currentVelocity$ | async)}} km/h</div>
      </div>

      <div class="top-box-right">
        <div class="follow-train-button">
          <qm-follow-train-button [feature]='currentTrain$ | async'></qm-follow-train-button>
        </div>
      </div>

    </div>
  </div>
</ng-container>
